import React from "react"
import { Modal, Button, Flex } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { Icon } from "ui/Icon"
import styles from "../roleModals.module.css"

const DeleteRoleModal = ({ open, onCancel, onConfirm, roleName }) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    onConfirm()
    onCancel()
  }

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={480}
      className={styles.roleModal}
      closeIcon={
        <span className={styles.closeIcon}>
          <Icon type="feather" name="X" />
        </span>
      }
    >
      <div className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>{t("staff.role_modal.delete_title")}</h2>
      </div>

      <div className={styles.modalBody}>
        <Text className={styles.deleteMessage}>{t("staff.role_modal.delete_message", { roleName: <strong>{roleName}</strong> })}</Text>
      </div>

      <Flex gap={12} className={styles.modalFooter}>
        <Button size="large" onClick={onCancel}>
          {t("staff.role_modal.cancel")}
        </Button>
        <Button type="primary" danger size="large" onClick={handleConfirm}>
          {t("staff.role_modal.delete")}
        </Button>
      </Flex>
    </Modal>
  )
}

export default DeleteRoleModal
